const initialState = {
  all: []
}

export function orderTypes(state=initialState, action) {
  const { payload } = action

  switch (action.type) {
    case 'FETCH_ORDER_TYPES_SUCCESS':
      return { ...state, all: payload }

    default:
      return state;
  }
}


